var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoltSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 52.0432,
    height: 94.8665,
    viewBox: "0 0 52.0432 94.8665",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008670",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34625692",
    filter: "url(#filter0_f_0_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23638 6.6165L13.387 6.12071L17.0111 87.6291L10.8763 92.6301L2.23638 6.6165Z",
    fill: "url(#paint0_linear_0_51)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34625694",
    filter: "url(#filter1_f_0_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8068 4.80068L31.6298 2.23638L20.2326 83.0254L29.9152 89.1617L49.8068 4.80068Z",
    fill: "url(#paint1_linear_0_51)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34625693",
    filter: "url(#filter2_f_0_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6008 6.75704H26.9127L23.9036 88.346L13.6008 87.0577V6.75704Z",
    fill: "url(#paint2_linear_0_51)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_51",
    x: -8.72133e-8,
    y: 3.88433,
    width: 19.2475,
    height: 90.9822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11819,
    result: "effect1_foregroundBlur_0_51"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_51",
    x: 17.9962,
    y: -5.8204e-8,
    width: 34.0469,
    height: 91.3981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11819,
    result: "effect1_foregroundBlur_0_51"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_51",
    x: 11.3644,
    y: 4.52065,
    width: 17.7847,
    height: 86.0617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11819,
    result: "effect1_foregroundBlur_0_51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_51",
    x1: 5.62369,
    y1: 32.8858,
    x2: 23.2015,
    y2: 101.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD18",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_51",
    x1: 36.5409,
    y1: 6.78035,
    x2: 18.2727,
    y2: 97.1788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD18",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_51",
    x1: 18.9692,
    y1: 17.1452,
    x2: 29.4892,
    y2: 102.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD18",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD18"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltSm);
export default __webpack_public_path__ + "static/media/bolt_sm.6cbb481b9d85b7ac42eb7ba581bd21b5.svg";
export { ForwardRef as ReactComponent };